var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-2 elevation-0",attrs:{"color":"#f5deb3"}},[_c('h5',{staticClass:"text-center mt-3"},[_vm._v(_vm._s(_vm.dadosLogado.usuario))])]),_c('v-list',[_c('MunuServidor'),_c('v-divider'),(_vm.dadosLogado.adminWeb)?_c('MenuAdministrativo'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }